import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import Main from '../Main.vue';
import homeIndex from '@/components/homeIndex/homeIndex';
// 引导页
import Init from '@/components/init/init';
// 内页
import InnerPager from '@/components/innerPager/innerPager';
// 文章详情页
import ArticleDetail from '@/components/articleDetail/articleDetail'
//在线留言
import onlineMessage from '@/components/contactUs/onlineMessage';
//在线咨询
import onlineConsultation from '@/components/contactUs/onlineConsultation';
//招商与合作
import attractInvestment from '@/components/contactUs/attractInvestment';
// 搜索结果列表
import searchList from '@/components/searchList/searchList';

import page404 from '@/components/error/page404'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'INIT',
      component: Init
    },
    {
      path: '/',
      redirect: '/admin/init'
    },
    {
      path: '/admin',
      name: 'home',
      component: Main,
      children: [
        {
          path: 'index',
          name: 'HOMEINDEX',
          component: homeIndex,
        },
        { // 在线留言
          path: 'onlineMessage',
          name: 'ONLINEMESSAGE',
          component: onlineMessage,
        },
        { //在线咨询
          path: 'onlineConsultation',
          name: 'ONLINECONSULTATION',
          component: onlineConsultation
        },
        { //招商与合作
          path: 'attractInvestment',
          name: 'ATTRACTINVESTMENT',
          component: attractInvestment
        },
        {
          path: 'inner-pager',
          name: 'INNERPAGER',
          component: InnerPager
        },
        {
          path: 'article-detail',
          name: 'ARTICLEDETAIL',
          component: ArticleDetail
        },
        { // 查询列表页
          path: 'search-list',
          name: 'SEARCHLIST',
          component: searchList
        }
      ]
    },
    {
      path: '/page404',
      name: 'page404',
      component: page404,
      meta: {
        title: 'Page not found'
      }
    },
    {
      path: '*',
      redirect: '/page404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js